import React, {useState, useEffect, useRef, memo} from 'react';
import './scss/Slider.scss'
//icon
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';

 const Slider = (props) => {

    const sliderWidth = useRef(null)
    const itemNumber = props.itemNumber || 0
    const [itemPerRow, setItemPerRow] = useState(props.itemPerRow || 1)
    const dots = props.dots===undefined ? true : props.dots
    const arrow = props.arrow===undefined ? true : props.arrow
    const [currentIndex, setCurrentIndex] = useState(0);
    const [tranlateValue, setTranslateValue] = useState(0)

    //resize
    const handleResize = ()=>{
        if(props.itemPerRow!==1 && window.innerWidth>700 && window.innerWidth<1100){
            setItemPerRow(2)
        }
        else if(props.itemPerRow!==1 && window.innerWidth<700){
            setItemPerRow(1)
        }else{
            setItemPerRow(props.itemPerRow)
        }
        setCurrentIndex(0)
        setTranslateValue(sliderWidth.current.offsetWidth)
    }

    useEffect(()=>{
        if(window.innerWidth>700 & window.innerWidth<1100){
            setItemPerRow(2)
        }
        if(window.innerWidth<700){
            setItemPerRow(1)
        }
         //add resize handler
         window.addEventListener("resize", handleResize);
         //checkcurrent window size
        setTranslateValue(sliderWidth.current.offsetWidth)

        return ()=>{
            //remove resize handler
           window.removeEventListener("resize", handleResize);
       }
    },[])

     //go to next slide
    function goNext(){
        if(currentIndex>=Math.floor(itemNumber/itemPerRow)){
            setCurrentIndex(0);
        }else{
            setCurrentIndex(currentIndex+1);
        }
    }

    //go to prev slide
    function goPrev(){
        if(currentIndex<=0){
            setCurrentIndex(Math.floor(itemNumber/itemPerRow));
        }else{
            setCurrentIndex(currentIndex-1);
        }
    }

    function goto(index){
        setCurrentIndex(index)
    }

    return(
        <div className="custom-slider mt-5" >
            <div className="wrapper" ref={sliderWidth} style={{transform: `translateX(-${tranlateValue*currentIndex}px)`}}>
                {React.Children.map(props.children, (child,index)=>(
                    <div className="slide" key={index} style={{minWidth:`${100/itemPerRow}%`}}>{child}</div>
                ))}
            </div>

            {arrow ? 
                <React.Fragment>
                    <div className="arrow arrow-left" onClick={()=>goPrev()} >
                        <KeyboardArrowLeftIcon />
                    </div>
                    <div className="arrow arrow-right" onClick={()=>goNext()}>
                        <KeyboardArrowRightIcon />
                    </div>
                </React.Fragment>
                :
                <></>
            }
            {dots ?
                <ul className="dots">
                    {Array((itemNumber%itemPerRow)>0 ? Math.floor((itemNumber/itemPerRow)+1) : itemNumber/itemPerRow).fill(undefined).map((a, index)=>
                        <li className={currentIndex===index ? 'active' : ''} key={index} onClick={()=>goto(index)}><span></span></li>
                    )}
                </ul>
                :
                <></>
            }
        </div>
    );
}

export default memo(Slider)